var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	49815: {
		fallback: () => (__webpack_require__.e(5988).then(() => (() => (__webpack_require__(75988))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	16058: {
		fallback: () => (() => (__webpack_require__(50633))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	75244: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(44489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	46467: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(44349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	27800: {
		fallback: () => (() => (__webpack_require__(7170))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	24137: {
		fallback: () => (() => (__webpack_require__(24518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	76890: {
		fallback: () => (() => (__webpack_require__(48591))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	27223: {
		fallback: () => (__webpack_require__.e(3648).then(() => (() => (__webpack_require__(83648))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	59963: {
		fallback: () => (__webpack_require__.e(8128).then(() => (() => (__webpack_require__(38128))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	83676: {
		fallback: () => (__webpack_require__.e(7738).then(() => (() => (__webpack_require__(77738))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	75065: {
		fallback: () => (__webpack_require__.e(19).then(() => (() => (__webpack_require__(10019))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	85233: {
		fallback: () => (() => (__webpack_require__(9971))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.5.2",
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zustand",

	},
	94014: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(72181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	91324: {
		fallback: () => (__webpack_require__.e(2732).then(() => (() => (__webpack_require__(52732))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-hook-form",

	},
	91292: {
		fallback: () => (__webpack_require__.e(4406).then(() => (() => (__webpack_require__(84406))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@tanstack/react-query",

	},
	14084: {
		fallback: () => (() => (__webpack_require__(64435))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	19775: {
		fallback: () => (() => (__webpack_require__(38747))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-user-store",

	},
	73867: {
		fallback: () => (() => (__webpack_require__(92458))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-basket-store",

	},
	52949: {
		fallback: () => (__webpack_require__.e(8386).then(() => (() => (__webpack_require__(58386))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	30272: {
		fallback: () => (__webpack_require__.e(4330).then(() => (() => (__webpack_require__(14330))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "axios",

	},
	70218: {
		fallback: () => (__webpack_require__.e(1192).then(() => (() => (__webpack_require__(1192))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "zod",

	},
	482: {
		fallback: () => (__webpack_require__.e(8383).then(() => (() => (__webpack_require__(98383))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-phone-number-input",

	},
	43691: {
		fallback: () => (__webpack_require__.e(1178).then(() => (() => (__webpack_require__(71178))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-lazily",

	},
	67613: {
		fallback: () => (__webpack_require__.e(4803).then(() => (() => (__webpack_require__(47184))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@hookform/resolvers",

	},
	15957: {
		fallback: () => (() => (__webpack_require__(95445))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-toast-store",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [49815,16058,75244,46467,27800,24137,76890,27223,59963,83676,75065,85233,75244,46467,94014,24137,85233,91292,16058,14084,19775,76890,73867,52949,30272,70218,482,43691];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		91292,
		16058,
		14084,
		19775,
		76890,
		73867,
		52949,
		30272,
		70218,
		482
	],
	"1324": [
		91324
	],
	"3691": [
		43691
	],
	"3872": [
		15957
	],
	"5527": [
		16058,
		75244,
		46467,
		27800,
		24137,
		76890,
		27223,
		59963,
		83676,
		75065,
		85233
	],
	"6678": [
		67613
	],
	"8792": [
		75244,
		46467,
		94014,
		24137,
		85233
	],
	"9815": [
		49815
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}